// extracted by mini-css-extract-plugin
export default {"pageContainer":"mainPageComponent_pageContainer__Lluh9","mainContainer":"mainPageComponent_mainContainer__nf7SJ"};